// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8cbdcbb9","453":"8df27226","732":"7b5e2241","977":"00c50a80"}[chunkId] + ".chunk.js";
};